module.exports = __webpack_public_path__ + "images/img-iyDMDVa.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/12.png
// module id = 2336
// module chunks = 0